// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionDescription_root__3UJD-","full":"QuestionDescription_full__3aQPG"};